import S3 from 'aws-sdk/clients/s3';
import SSM from 'aws-sdk/clients/ssm';
import { fetchAuthSession } from 'aws-amplify/auth';

export async function copyDocFromInternalToCustomer({ internalDocPath, customerDocPath, customerDocName }) {
  const { credentials } = await fetchAuthSession();
  const s3Client = new S3({
    region: 'us-east-1',
    credentials: {
      accessKeyId: credentials.accessKeyId,
      secretAccessKey: credentials.secretAccessKey,
      sessionToken: credentials.sessionToken
    }
  });
  const ssmClient = new SSM({
    region: 'us-east-1',
    credentials: {
      accessKeyId: credentials.accessKeyId,
      secretAccessKey: credentials.secretAccessKey,
      sessionToken: credentials.sessionToken
    }
  });

  const getParametersResponse = await new Promise((resolve) => {
    ssmClient.getParameters(
      {
        Names: ['POLICY_DOCS_S3_BUCKET'],
        WithDecryption: true
      },
      (_err, data) => {
        resolve(data);
      }
    );
  });

  const bucket = getParametersResponse && getParametersResponse.Parameters && getParametersResponse.Parameters[0].Value;
  try {
    const data = await new Promise((resolve, reject) => {
      s3Client.copyObject(
        {
          Bucket: bucket,
          CopySource: `${bucket}/${internalDocPath}`,
          Key: `${customerDocPath}/${customerDocName}`
        },
        (err, copyData) => {
          if (err) {
            reject(err);
          } else {
            resolve(copyData);
          }
        }
      );
    });
    return { data, success: true };
  } catch (err) {
    console.log(err);
    return { success: false };
  }
}
